import PropTypes from 'prop-types'
import { Button, Chip } from '@material-ui/core'
import { reverse } from 'named-urls'
import { useHistory } from 'react-router-dom'
import clsx from 'clsx'

import { MenuButton, Permitted } from 'components'
import { TableRow, TableCell } from 'components/Table'
import { routes } from 'Routes'

import helpers from 'helpers'
import constants from 'constants/index'

import useStyles from './styles'

const ProfilesTableRow = ({
  profile,
  isCollaborator,
  handleInactivateProfile,
  isAdvisor,
}) => {
  const history = useHistory()
  const classes = useStyles()

  const permissions = isCollaborator
    ? constants.permissions.COLLABORATOR_PROFILES
    : constants.permissions.CLIENT_PROFILES
  const labelToChangeStatus = profile?.status ? 'inativar' : 'ativar '

  const redirectEdit = () => {
    if (isCollaborator) {
      history.push(
        reverse(routes.collaboratorProfiles.edit, {
          collaboratorProfileId: profile.id,
        }),
      )

      return
    }

    if (isAdvisor) {
      history.push(
        reverse(routes.userProfiles.editOrganizations, {
          userProfileId: profile.id,
        }),
      )

      return
    }

    history.push(
      reverse(routes.userProfiles.edit, {
        userProfileId: profile.id,
      }),
    )
  }
  const isAdmin =
    profile?.id === constants.profile.ADMIN_PROFILE_ID ||
    profile?.id === constants.profile.ADVISOR_ADMIN_PROFILE_ID

  return (
    <>
      <TableRow key={profile.id}>
        <TableCell disableTooltip>{profile.id}</TableCell>
        <TableCell>{profile.name}</TableCell>
        <TableCell>{profile.description}</TableCell>

        {!isCollaborator && (
          <>
            <TableCell>
              {isAdvisor
                ? profile?.organization?.name || 'Todos os grupos advisor'
                : profile?.company?.name || 'Todas as empresas'}
            </TableCell>
            <TableCell disableTooltip>
              {helpers.profiles.checkDefault(profile)}
            </TableCell>
          </>
        )}
        <TableCell disableTooltip>
          <Chip
            className={clsx(classes.root, {
              [classes.active]: profile.status,
              [classes.inactive]: !profile.status,
            })}
            align="center"
            size="small"
            label={profile.status ? 'Ativo' : 'Inativo'}
          />
        </TableCell>
        <TableCell disableTooltip align="right">
          <Permitted someTags={[permissions.EDIT, permissions.DESTROY]}>
            <MenuButton disabled={isAdmin}>
              {profile?.id !== 1 && (
                <>
                  <Permitted tag={permissions.EDIT}>
                    <Button onClick={redirectEdit} fullWidth size="small">
                      Editar
                    </Button>
                  </Permitted>
                  {!profile?.default && (
                    <Permitted tag={permissions.DESTROY}>
                      <Button
                        onClick={() => handleInactivateProfile(profile)}
                        fullWidth
                        size="small"
                      >
                        {labelToChangeStatus}
                      </Button>
                    </Permitted>
                  )}
                </>
              )}
            </MenuButton>
          </Permitted>
        </TableCell>
      </TableRow>
    </>
  )
}

ProfilesTableRow.propTypes = {
  profile: PropTypes.object,
  isCollaborator: PropTypes.bool,
  handleInactivateProfile: PropTypes.func,
  isAdvisor: PropTypes.bool,
}

export default ProfilesTableRow
